export abstract class ISessionService {
  public abstract init(): void;

  public abstract startSession(): void;

  public abstract stopSession(): void;

  public abstract restartSession(): void;
}
